import React from 'react';
import { useReveal } from '../lib/useReveal';
export function VideoSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section className="bg-[#f5ede0] py-20 md:py-28 px-4" data-id="element-367">
      <div className="container mx-auto max-w-4xl" data-id="element-368">
        {/* Header */}
        <div ref={ref1} className={`reveal text-center mb-12 ${vis1 ? 'is-visible' : ''}`} data-id="element-369">
          <div className="inline-flex items-center gap-2 text-[#b8860b] text-xs font-bold tracking-[0.3em] uppercase mb-5" data-id="element-370">
            <span className="w-8 h-px bg-[#b8860b]/40" data-id="element-371"></span>
            Tómate unos minutos
            <span className="w-8 h-px bg-[#b8860b]/40" data-id="element-372"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#2a1f0e] leading-tight mb-4" data-id="element-373">
            Así va a sonar{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b8860b] via-[#e8c44a] to-[#b8860b]" data-id="element-374">
              tu vida
            </span>
          </h2>
          <p className="text-[#5c4a2a]/70 text-lg max-w-xl mx-auto" style={{
          fontFamily: "'Cormorant Garamond', serif"
        }} data-id="element-375">
            Descubrí cómo está estructurada la formación y qué vas a aprender
            paso a paso.
          </p>
        </div>

        {/* Video with golden frame */}
        <div ref={ref2} className={`reveal ${vis2 ? 'is-visible' : ''}`} data-id="element-376">
          <div className="relative" data-id="element-377">
            <div className="absolute -inset-3 bg-gradient-to-br from-[#d4a017]/25 via-[#f0c040]/15 to-[#d4a017]/20 rounded-3xl blur-2xl opacity-80" data-id="element-378"></div>
            <div className="relative p-1 rounded-2xl bg-gradient-to-br from-[#d4a017]/50 via-[#f5ede0]/10 to-[#d4a017]/40 shadow-[0_20px_80px_rgba(184,134,11,0.3)]" data-id="element-379">
              <div className="rounded-xl overflow-hidden" data-id="element-380">
                <div className="aspect-video w-full" data-id="element-381">
                  <iframe src="https://www.youtube.com/embed/i-m-injF6xs?rel=0&modestbranding=1" title="Curso Integral de Reiki" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="w-full h-full" data-id="element-382" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}